import { useEffect, useState } from 'react';
import { Card, Tabs } from '@mantine/core';
import { IconFilter, IconSettings } from '@tabler/icons-react';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';
import Spinner from '../Spinner';
import BoostAndFiltersProductFeedForm from './boostAndFiltersProductFeedForm';
import GeneralProductFeedForm from './generalProductFeedForm';

const ProductFeedFormFields = ({ productFeed, setProductFeed, tab, setTab }) => {
  const { accountId, domainId } = useParams();
  const fetch = useFetch();

  const [customFields, setCustomFields] = useState();
  const [error, setError] = useState();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/customFields`)
      .then(({ customFields }) => {
        setCustomFields(customFields);
      })
      .catch(setError);
  }, [fetch, accountId, domainId]);

  if (!customFields) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }
  const addRule = (rule, cb) => {
    setProductFeed({ ...productFeed, rules: [...productFeed.rules, rule] });
    if (cb) {
      cb();
    }
  };

  const removeRule = (index) => {
    setProductFeed((prev) => {
      const newRules = prev.rules.splice(prev.rules, index);
      return { ...prev, rules: newRules };
    });
  };

  const updateRule = (index, changes) => {
    const rules = [...productFeed.rules];
    rules[index] = { ...rules[index], ...changes };
    setProductFeed({ ...productFeed, rules });
  };

  const handleChange = (e) => {
    let change = {};
    change[e.target.name] = e.target.value;
    if (e.target.name === 'optionsEnableDays') {
      setProductFeed((prev) => ({
        ...prev,
        options: e.target.value ? { days: 30 } : {},
      }));
    } else if (e.target.name === 'optionsDays') {
      setProductFeed((prev) => ({
        ...prev,
        options: { ...prev.options, days: e.target.value },
      }));
    } else {
      setProductFeed({ ...productFeed, ...change });
    }
  };

  return (
    <Tabs value={tab} onChange={setTab} mb="md" keepMounted>
      <Tabs.List>
        <Tabs.Tab value="general" leftSection={<IconSettings size={16} />}>
          General
        </Tabs.Tab>
        <Tabs.Tab value="boostsAndFiltrs" leftSection={<IconFilter size={16} />}>
          Boosts &amp; Filters
        </Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="general" pt={0}>
        <GeneralProductFeedForm
          productFeed={productFeed}
          handleChange={handleChange}
          setProductFeed={setProductFeed}
          setUserError={setError}
          addRule={addRule}
          removeRule={removeRule}
          updateRule={updateRule}
        />
      </Tabs.Panel>
      <Tabs.Panel value="boostsAndFiltrs" pt={0}>
        <Card withBorder>
          <Card.Section inheritPadding py="sm">
            <BoostAndFiltersProductFeedForm
              productFeed={productFeed}
              customFields={customFields}
              updateRule={updateRule}
              addRule={addRule}
            />
          </Card.Section>
        </Card>
      </Tabs.Panel>
    </Tabs>
  );
};

export default ProductFeedFormFields;
